import { render, staticRenderFns } from "./loadShipAdd.vue?vue&type=template&id=7f566368&"
import script from "./loadShipAdd.vue?vue&type=script&lang=js&"
export * from "./loadShipAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports